module.exports = __webpack_public_path__ + "img/blitz.20881325.jpg";